import React, { useEffect, useRef, useState } from 'react';


const Header = () => {
  const [emergencyOpen, setEmergencyOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);

	const [navstate, setNavstate] = useState(false);
  const [scroll, setScroll] = useState(0);

  const handleNavstate = () => {
    // console.log("navstate => ", navstate);
    if (!navstate) {
      setNavstate(true);
    } else {
      setNavstate(false);
    }
  };

  const handleScroll = () => {
    // console.log("window.scrollY => ", window.scrollY);
    setScroll(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  })
	
  return (
    <>
      {/* <div className="h-[58px] lg:h-[150px]"></div> */}
      <div className={`fixed flex xl:flex-col top-0 left-0 right-0 z-40 w-full justify-between ${scroll > 50 ? "bg-white" : "bg-[#0000]"} ${scroll && "shadow-[0_4px_10px_rgba(0,191,255,0.2)]"} transition-all duration-500`}>
        
        {/* MAIN HEADER */}
				<header className={`py-[25px] xl:py-2 ${navstate && "nav-menu"} transition-all duration-500`}>
					<div className="flex justify-between items-center mx-auto px-[15px] max-w-[1200px]">
						{/* LOGO */}
						<div className="flex items-center gap-[5px] w-[44px] h-[44px]">
							<img
								src="/png/logo.png"
								className="h-full md:h-full xl:w-full"
								alt="logo"
							/>
              <span className={`text-[#${scroll > 50 ? "2d52ab" : "fff"}] text-[20px] font-semibold`}>WalletScanner</span>
						</div>
						{/* NAVBAR */}
						<nav className="hidden xl:flex items-center font-medium leading-tight">
							<a href="#" className="nav-link py-[30px] px-5 text-[#00bfff] tracking-[0.008em]">
								Home
							</a>
							<a href="#about-us" className={`nav-link py-[30px] px-5 text-${scroll > 50 ? "black" : "white"} tracking-[0.008em]`}>
								About Us
							</a>
							<a href="#pricing" className={`nav-link py-[30px] px-5 text-${scroll > 50 ? "black" : "white"} tracking-[0.008em]`}>
								Pricing
							</a>
							<a
								href="#check"
								className="bg-[#0F4F87] bg-gradient-to-r from-[#9568ff] to-[#9568ff] rounded-lg text-white py-3.5 px-[30px] ml-10 transition-all duration-300 hover:bg-white hover:text-[#0F4F87] text-[15px] shadow-[0_4px_10px_rgba(0,191,255,0.2)]"
							>
								Get Started
							</a>
						</nav>
					</div>
				</header>

        {/* BURGER MENU */}
        <div className="flex xl:hidden items-center justify-center bg-inherit mr-[15px] !max-w-full relative">
          <label className="absolute flex w-[50px] bg-[#01BFFF] rounded-[6px] px-[13px] py-[18px] right-[1rem] top-[1.4rem] justify-between flex-col" style={{"cursor": "pointer"}} onClick={handleNavstate}>
            <div className={`h-[1px] bg-[#fff] z-[999] rounded-[3px] transition-all duration-500 ${navstate ? "bg-white transform translate-y-[6px] transform rotate-45" : "transform translate"} mb-[5px]`}></div>
            <div className={`h-[1px] bg-[#fff] z-[999] rounded-[3px] transition-all duration-500 ${navstate ? "opacity-0" : "opacity-1"} mb-[5px]`}></div>
            <div className={`h-[1px] bg-[#fff] z-[999] rounded-[3px] transition-all duration-500 ${navstate ? "bg-white transform -translate-y-[6px] transform -rotate-45" : "transform translate"}`}></div>
          </label>
          <div className={`fixed w-[280px] h-[100vh] bg-[#fff] left-0 top-[0] z-0 transition-all duration-500 ease-[cubic-bezier(0.19, 1, 0.22, 1)] ${navstate ? "transform translate-x-0" : "transform translate-x-[-101%]"} px-[20px]`}>
            <div className='max-w-[100px] py-[30px] m-auto'>
              <img src='/png/logo-color.png' />
            </div>
            <ul className=''>
              <li className="px-[10px] py-[15px] list-none text-[15px] leading-none border-b text-[#1c2e9e] text-center border-[#0000001a]">
                <a href="#" onClick={handleNavstate}>Home</a>
              </li>
              <li className="px-[10px] py-[15px] list-none text-[15px] leading-none border-b text-[#1c2e9e] text-center border-[#0000001a]">
                <a href="#about-us" onClick={handleNavstate}>About Us</a>
              </li>
              <li className="px-[10px] py-[15px] list-none text-[15px] leading-none border-b text-[#1c2e9e] text-center border-[#0000001a]">
                <a href="#pricing" onClick={handleNavstate}>Pricing</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
